import React, { useState } from 'react';
import Filter from './Filter';
import List from './List';

const Section = () => {
  const [filter, setFilter] = useState({
    penyelenggara: '', jenis_kegiatan: '', tanggal: '', nama_kegiatan: '',
  });

  const [appliedFilter, setAppliedFilter] = useState({
    penyelenggara: '', jenis_kegiatan: '', tanggal: '', nama_kegiatan: '',
  });

  const handleApplyFilter = () => {
    setAppliedFilter({ ...appliedFilter, ...filter });
  };

  return (
    <>
      <Filter
        filter={filter}
        setFilter={setFilter}
        appliedFilter={appliedFilter}
        handleApplyFilter={handleApplyFilter}
      />
      <List appliedFilter={appliedFilter} />
    </>
  );
};

export default Section;
